export default "__VITE_ASSET__49a54015__"